import { createEvent } from 'effector';

const onFlatFovChanged = createEvent<{
  fovmin: number;
  fovmax: number;
  needUpdateFov: boolean;
}>();

export default onFlatFovChanged;
